import { KYC_STEPS } from "./kycSteps";

const STORAGE_PREFIX = "kyc-progress:";
const VALID_STEPS = new Set(Object.values(KYC_STEPS));

const getStorageKey = (sessionId) =>
  sessionId ? `${STORAGE_PREFIX}${sessionId}` : "";

const getRestorableStep = (step) => {
  if (!VALID_STEPS.has(step)) return "";

  // Object URLs do not survive a refresh, so an image review must restart capture.
  if (step === KYC_STEPS.DOCUMENT_REVIEW) {
    return KYC_STEPS.DOCUMENT_CAPTURE;
  }

  // The front-side image is an object URL too. A refresh on the back-side guide
  // must restart from the front instead of leaving the user without that image.
  if (step === KYC_STEPS.DOCUMENT_BACK_PREPARATION) {
    return KYC_STEPS.DOCUMENT_CAPTURE;
  }

  return step;
};

const load = (sessionId) => {
  const key = getStorageKey(sessionId);
  if (!key) return "";

  try {
    return getRestorableStep(localStorage.getItem(key));
  } catch {
    return "";
  }
};

const save = (sessionId, step) => {
  const key = getStorageKey(sessionId);
  if (!key || !VALID_STEPS.has(step)) return;

  try {
    localStorage.setItem(key, step);
  } catch {
    // Storage can be unavailable in private browsing; the flow still works in memory.
  }
};

export const kycProgressStorage = { load, save };
